import React, { useState, useEffect, useRef } from "react";
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { useTour } from '@reactour/tour';
import { buildIntroSteps, buildAfterSubmitSteps, openTour, useTargetHighlight, waitForEls, waitForStableLayout } from './common/app-tour-guide'
import { useTourLauncher } from "../contexts/context-tour";
import AppTopBar2 from './common/app-top-bar2';
import AppLoading from './common/app-loading';
import {
  Button, Box, Chip, CircularProgress, Divider, Drawer,
  List, ListItem, ListItemButton, ListItemText, Select, Tooltip, Typography, MenuItem, TextField, Grid
} from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import PopShare from './essay/pop-share';
import IconButton from '@mui/material/IconButton';
import { AppHelper } from '../AppHelper';
import { EssayHelper } from '../helpers/essay.helper';
import EssayForm from './essay/essay-form-v2';
import EssayView from './essay/essay-view';
import SpaCheck from './common/spa-check';
import PopSuggestion from "./common/pop-suggestion";
import HomeAttempt from "./attempt-drawer";
import { useEssayContext } from "../contexts/context-essay";
import InfoIcon from "@mui/icons-material/Info";
const dayjs = require('dayjs');

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props}
          sx={{
            backgroundColor: '#b9f6ca',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#00c853'
            }
          }}
        />
      </Box>
      <Box>
        <Typography variant="body2" color="text.secondary" fontSize={"0.7rem"}
          sx={{
            color: props.recSelected == 1 ? 'rgba(0,0,0,0.9)' : 'text.secondary'
          }}>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}


export default function PageHomeEssay() {
  const navigate = useNavigate();
  var oUser = AppHelper.userCacheGet();
  const [iamTEA, setIamTEA] = useState(false);
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const [firstEssaySubmitted, setFirstEssaySubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [grade, setGrade] = useState("");
  const [gradeList, setGradeList] = useState([]);
  const drawerWidth = 320;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const [viewMode, setViewMode] = React.useState('NEW');
  const [refreshList, setRefreshList] = React.useState(false);
  const [recEssay, setRecEssay] = React.useState({});
  const [parentEssay, setParentEssay] = React.useState(null);
  const [autoSelectId, setAutoSelectId] = React.useState('');
  const scoreCodesV2 = [
    { c: 'GM', c2: 'grammar', n: 'Grammar', v: 0, p: 0, eg: [], sub: [], expand: false },
    { c: 'SP', c2: 'spelling', n: 'Spelling', v: 0, p: 0, eg: [], sub: [], expand: false },
    { c: 'VC', c2: 'vocabulary', n: 'Vocabulary', v: 0, p: 0, eg: [], sub: [], expand: false },
    { c: 'ST', c2: 'structure', n: 'Structure', v: 0, p: 0, eg: [], sub: [], expand: false },
  ];
  const [filterEssay, setFilterEssay] = React.useState('');
  const [profiles, setProfiles] = React.useState([]);
  const [profileId, setProfileId] = useState('');
  const refTopBar = useRef(null);
  const [isSa, setIsSa] = React.useState(false);
  const [popShowFeedbackOpen, setPopShowFeedbackOpen] = useState(false);
  const [popShareOpen, setPopShareOpen] = React.useState(false);
  const [attemptTitle, setAttemptTitle] = useState('');
  const isNewSubmissionDisabled = false;
  const showNewEssayButton = !!(recEssay && recEssay.essayId);
  const [formKey, setFormKey] = useState(0);

  useTargetHighlight();
  const { register } = useTourLauncher(); 

  const onShare = async () => {
    setPopShareOpen(true);
  }

  const popShareClose = () => {
    setPopShareOpen(false);
  }

  const { essayList, isEssayListLoaded, loadEssayList, essaySelect, essaySelectAttempt, essayRemove } = useEssayContext();

  useEffect(() => {
    if (!oUser) return;
    if (!isEssayListLoaded) {
      return;
    }
    else {
    }
  }, [isEssayListLoaded]);
  useEffect(() => {
    if (!oUser) {
      navigate('/login');
      return;
    }
    setIamTEA(oUser.accountType == 'TEA');
    essaySelect('');
    AppHelper.apiAuditPost("P-H", "");
    if (!oUser.profileId) {
    }
    if (profileId == '') setProfileId(oUser.profileId);

    const fetchIAM = async () => {
      var _res = await AppHelper.apiPost('api/account/iam', { token: oUser.token });
      if (!_res || !_res.status || !_res.data || !_res.data.isSa) {
        return;
      }
      setIsSa(true);
    }
    fetchIAM();
    const fetchProfiles = async () => {
      try {
	
        const response = await AppHelper.apiPost('api/profile-linked/list', { token: oUser.token });
        let profilesMap = new Map();
        if (response && response.status && response.data) {
			let profiles = response.data;
			profiles.forEach(x => {
        x.isOwnProfile = 1;
        profilesMap.set(x.profileId, x);
      });

      if (oUser.accountType == 'TEA'){
        const responseShare = await AppHelper.apiPost('api/profile/student/list', { token: oUser.token });
  
        if (responseShare && responseShare.data) {
          const profileShare = responseShare.data;
          profileShare.forEach(x => {
            if (!profilesMap.has(x.profileId)) {
              x.isOwnProfile = 0;
              profilesMap.set(x.profileId, x);
            }
          });
      }
			}

			setProfiles(Array.from(profilesMap.values()));							       
        } else {
          console.error('Failed to fetch profiles:', response);
        }
      } catch (error) {
        console.error('Error fetching profiles:', error);
      }
    };
    fetchProfiles();

    const fetchGrades = async () => {
      const gradeRes = await EssayHelper.essayGradeGet(oUser.token);
      if (!gradeRes || gradeRes.length < 1) {
        alert('Failed to load the grade list! ' + oUser.token);
        return;
      }
      setGradeList(gradeRes);

      if (!grade) {
        const defaultGrade = gradeRes.find(
          g => g.v === (oUser && oUser.grade ? oUser.grade : 'P5')
        );
        if (defaultGrade) {
          setGrade(defaultGrade.v);
        }
      }
    };
    fetchGrades();

  }, []);

  const startTour = React.useCallback(async () => {
    try {
      const hasMultipleProfiles = profiles.length > 1;
      const selectors = ['#grade-select', '#select-question-btn', '#scan-essay-btn'];
      if (hasMultipleProfiles) selectors.unshift('#profile-select');

      try {
        await waitForEls(selectors);
        await waitForStableLayout(selectors, 3, 120);
      } catch (_) {}

      const steps = buildIntroSteps({ hasMultipleProfiles });
      if (steps.length) {
        openTour({ setSteps, setCurrent: setCurrentStep, setIsOpen }, steps);
        return;
      }
    } catch (e) {
      // Fallback to help button
      const fallback = [{ selector: '#help-tour-btn', content: 'Re-open the tutorial here.' }]
        .filter(s => document.querySelector(s.selector));
      if (fallback.length) {
        openTour({ setSteps, setCurrent: setCurrentStep, setIsOpen }, fallback);
      }
    }
  }, [profiles.length, setSteps, setCurrentStep, setIsOpen]);


  useEffect(() => {
    const unregister = register(async () => {
      if (viewMode === 'VIEW') {
        try {
          await waitForEls(['#improve-essay-btn', '#try-again-btn', '#report-card-btn', '#share-btn'], 2000, 100);
        } catch (_) {  }
        openTour(
          { setSteps, setCurrent: setCurrentStep, setIsOpen },
          buildAfterSubmitSteps()
        );
      } else {
        await (async () => {
          try {
            await startTour();
          } catch (_) {}
        })();
      }
    });
    return unregister;
  }, [register, viewMode, setSteps, setCurrentStep, setIsOpen, startTour]);

  useEffect(() => {
    setFirstEssaySubmitted(false);
    if (!isEssayListLoaded) return;
    const hasShown = sessionStorage.getItem('tourShown');
    if (hasShown) return;
    startTour(); 
    sessionStorage.setItem('tourShown', 'true');

    // console.log("Essay count: ", essayList.length);
    // if (essayList.length <= 1) {
    //   startTour();
    // }
    // if (essayList.length === 2) {
    //   setFirstEssaySubmitted(true);
    // }
  }, [isEssayListLoaded, essayList]);

  const handleGradeChange = (event) => {
    setGrade(event.target.value);
  };


  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };
  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };
  const onEssaySelect = (arg) => {
    setParentEssay(null);
    setRecEssay(arg);
    setViewMode(arg.status == 0 ? 'NEW' : 'VIEW');
    essaySelect(arg.essayId);
    if (mobileOpen) setMobileOpen(false);
  };
  
  const onEssayAttemptSelect = (arg, parentEssay) => {	    
    setRecEssay(arg);
    setViewMode(arg.status == 0 ? 'NEW' : 'VIEW');
	  essaySelectAttempt(arg.essayId, parentEssay.essayId);
    if (mobileOpen) setMobileOpen(false);
  };
  
  const essayFormDone = (arg) => {
    if (arg.code && arg.code == 'NEW') {
      setAutoSelectId(arg.essayId);
      if (oUser) loadEssayList(oUser, arg.essayId);

      setRecEssay({ 
        essayId: arg.essayId,
        status: 5,
        isSample: 0 
      });
      setViewMode('VIEW');
    }
    else {
      setRefreshList(!refreshList);
    }
  };

  const essayViewDone = (arg) => {
    setRefreshList(!refreshList);
    if (arg.code && arg.code == 'NEW') {
      setAutoSelectId(arg.essayId);
      setRecEssay(prev => ({ ...prev, essayId: arg.essayId }));
    }
    else if (arg.code && arg.code == 'DELETE') {
      setViewMode('NEW');
      essayRemove(arg.essayId);
    }
    else if(arg.code && arg.code == 'CHANGE'){
      var _rec = {...recEssay, essayId: arg.essayId};
      setRecEssay(_rec);
    }
    else {
      setViewMode('NEW');
    }
  };

  const essayDetailLoaded = (arg) => {
    setParentEssay({...arg});
  }
  const onTryAgain = async () => {
    setViewMode('NEW');
    essaySelect('');
    setRecEssay({
      topic: "",
      text: "",
      essayId: ""
    });
    setAutoSelectId("");
    if (mobileOpen) setMobileOpen(false);

    var _user = AppHelper.userCacheGet();
    if(!_user) return;
    AppHelper.apiPost('api/essay/attempts', { token: _user.token, essayId: recEssay.essayId }).then(_resAttempts => {
      if(_resAttempts.status){
        setAttemptTitle('Attempt ' + (_resAttempts.data.length+1));
      }
    });
  }
  const essayAddClick = () => {
    setParentEssay(null);
    setViewMode('NEW');
    essaySelect('');
    setRecEssay({
      topic: "",
      text: "",
      essayId: ""
    });
    setAutoSelectId("");
    if (mobileOpen) setMobileOpen(false);
    setFormKey(prev => prev + 1);
  }
  const filterEssayChange = (event) => {
    setFilterEssay(event.target.value);
  };
  const drawerItemColrs = {
    '1x': 'rgba(0,0,0,0.25)',
    '1xx': 'rgb(157, 188, 152)',
    '1xxx': 'rgb(99, 136, 137)',
    '1': '#d3d3d3',//'rgba(19,130,117,1)',
    '0x': 'white',
    '0': '#fff'//'rgba(255,255,255,1)',//'rgb(235, 217, 180)',
  };
  const chipSampleColors = {
    '1': 'rgba(19,130,117,1)',
    '0': 'white'
  };
  const drawerItemColorsText = {
    '1': 'rgba(255,255,255,1)',
    '0': 'rgba(0,0,0,0.6)',
  };
  const listFilterEssay = () => {
    var _list = [...essayList];
    if (filterEssay && filterEssay.length > 0) {
      var _filterText = filterEssay.toLowerCase();
      _list = _list.filter(r =>
        r.versionTitle.toLowerCase().includes(_filterText)
      );
    }
    return _list;
  };
  const visibleEssays = React.useMemo(
    () =>
      listFilterEssay()
    ,
    [essayList, filterEssay]
  );
  const profileSelect = async (arg) => {
    setProfileId(arg.target.value);
    var _profile = profiles.find(p => p.profileId == arg.target.value);
    if (!_profile) {
      alert('Profile data not found!');
      return;
    }
    var _oUserSwitch = { ...oUser };
    _oUserSwitch.name = _profile.name;
    _oUserSwitch.profileId = _profile.profileId;
    _oUserSwitch.grade = _profile.grade;
    _oUserSwitch.picture = _profile.avatarImage;
    _oUserSwitch.avatarImage = _profile.avatarImage;
    _oUserSwitch.countryCode = _profile.countryCode;
    _oUserSwitch.locale = _profile.locale;
    if (_profile.isLinked == true) {
      _oUserSwitch.accountType = _profile.linkedRole;
    }
    AppHelper.userCacheSet(_oUserSwitch);
    oUser = AppHelper.userCacheGet();
    loadEssayList(oUser);
    if (refTopBar) {
	  setGrade(_profile.grade);
	  refTopBar.current.refreshProfile();
    }
    setParentEssay(null);
    setViewMode("NEW");
    essaySelect('');
    setRecEssay({
      topic: "", 
      text: "", 
      essayId: ""
    });
  };
  const mobileOpenClick = (arg) => {
    setMobileOpen(!mobileOpen);
  };
  const popShowFeedbackClose = () => {
    setPopShowFeedbackOpen(false);
  };

  const handleDeleteDraft = (draftId) => {
    setViewMode('NEW');
    essayRemove(draftId);

    setRecEssay({
      topic: '', 
      text: '', 
      essayId: ''
    });
    setParentEssay(null);
    setFormKey(prev => prev + 1);
  };

  const container = window !== undefined ? () => window.document.body : undefined;
  return (
    <Box sx={{ display: 'flex' }}>
      <AppTopBar2 mobileOpen={mobileOpen} mobileOpenClick={mobileOpenClick} ref={refTopBar} isEssayHome={true}/>
      {isLoading ? (
        <AppLoading />
      ) : (
        <>
          <Box backgroundColor="#000"
            component="nav"
            sx={{ width: { md: drawerWidth }, flexShrink: { sm: 0, md: 0 }, border: '0 solid red' }}
          >
            <Drawer
              container={container}
              variant="temporary"
              open={mobileOpen}
              onTransitionEnd={handleDrawerTransitionEnd}
              onClose={handleDrawerClose}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
              sx={{
                display: { xs: 'block', sm: 'block', md: 'none' },
                minWidth: '300px',
              }}
            >
              <HomeAttempt 
                onEssayAttemptSelect={onEssayAttemptSelect} 
                onEssaySelect={onEssaySelect} 
                essayAddClick={essayAddClick} 
                isSa={isSa} 
                viewMode={viewMode}
                showNewEssayButton={showNewEssayButton}
                />
            </Drawer>
            <Drawer
              variant="permanent"
              sx={{
                display: { xs: 'none', sm: 'none', md: 'block' },
                minWidth: '300px'
              }}
              PaperProps={{
                sx: {
                  backgroundColor: '#f1f1f1',
                  marginTop: '65px',
                  width: drawerWidth
                }
              }}
              open
            >
              <HomeAttempt 
                onEssayAttemptSelect={onEssayAttemptSelect} 
                onEssaySelect={onEssaySelect} 
                essayAddClick={essayAddClick} 
                isSa={isSa} 
                viewMode={viewMode} 
                showNewEssayButton={showNewEssayButton}
              />
            </Drawer>
          </Box>
          <Box
            component="main"
            sx={{ flexGrow: 1, p: 3, width: { md: `calc(100% - ${drawerWidth}px)` }, marginTop: '50px' }}
          >
            <Grid container>
              <Grid item xs={viewMode === "VIEW" ? 4 : 12}>
                <Box display="flex" alignItems="center">
                {profiles && profiles.length > 1 && (
                  <Select labelId='lblProfile' id='profile-select'
                    value={profileId}
                    onChange={profileSelect}
                    label=""
                    sx={{ "& fieldset": { border: 'none' }, marginLeft: '-12px' }}
                    
                  >
                    {profiles.map((item) => (
                     
					  <MenuItem key={item.profileId} value={item.profileId}>
            <>
            <Chip label={item.grade} variant="filled" style={{
              backgroundColor: chipSampleColors[item.selected == '1' ? '0' : '1'],
              color: chipSampleColors[item.selected == '1' ? '1' : '0'],
              height: "20px", 
              marginRight: '5px', 
            }}
            sx={{ fontSize: '.8rem', marginTop: '0rem', marginBottom: '0', padding: '0.1px', maxHeight: "28px", }}
            />
            </>
						{item.isOwnProfile === 0 ? `${item.name} (TC)` : 
             item.isLinked === true ? (
              <>
              <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
              <Typography component='span'>{item.name}</Typography>
                <Chip label={'LINKED'} variant="filled" style={{
                  backgroundColor: "grey",
                  color: "white",
                  size: "small", 
                  height: "20px", 
                  marginLeft: '5px',
                  marginRight: '-5px', 
                }} />
                <Tooltip sx={{marginRight: "-10px"}} title={`Linked from ${item.email}`}>
                  <IconButton sx={{height: "22px", }}>
                    <InfoIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              </>
             ) : 
             `${item.name}`}
					  </MenuItem>
                    ))}
                  </Select>
                )}
                <Box sx={{ flexGrow: 1 }} />
                {gradeList && gradeList.length > 0 && viewMode !== 'VIEW' && (
                  <Select
                    labelId="lblGrade"
                    id="grade-select"
                    value={grade}
                    onChange={handleGradeChange}
                    sx={{ "& fieldset": { border: 'none' } }}
                  >
                    {gradeList.map((item) => (
                      <MenuItem key={item.v} value={item.v}>
                        {item.n}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </Box>

              </Grid>
              { recEssay.status != 0 && 
              <Grid item xs={4} style={{ textAlign: 'center', alignContent: 'center' }}>
        {recEssay && recEssay.essayId && recEssay?.status == '5' && recEssay?.status == 5 && recEssay.isSample !== 1 && (
				  <>
					<Button
            id='try-again-btn'
					  className="app-btn-bg"
					  onClick={onTryAgain}
					  color="info"
					  variant="contained"
					>
					  TRY AGAIN
					</Button>
				  </>
				)}
				</Grid>
			  }
        { viewMode === 'VIEW' &&  
          <Grid item xs={4} style={{ textAlign: 'right', alignContent: 'center' }}>
          {recEssay && recEssay.essayId && recEssay.isSample !== 1 &&
            <Button id='share-btn' className="app-btn-bg" //sx={{backgroundColor:'rgba(19,130,117,1)', ":hover":{backgroundColor:'#00695c'}}} 
              onClick={onShare} color="info" variant="contained">SHARE</Button>
          }
          </Grid>
			  }
            </Grid>

            {
              viewMode == 'NEW' && !isNewSubmissionDisabled &&
              <EssayForm 
                key={formKey}
                profileGrade={grade} 
                parentEssay={parentEssay} 
                essayId={recEssay.essayId} 
                onDeleteDraft={handleDeleteDraft} 
                essayFormDone={essayFormDone} 
                profileId={profileId} 
                isSa={isSa} 
                grade={grade} 
                gradeList={gradeList}
              ></EssayForm>
            }
            {
              viewMode == 'NEW' && isNewSubmissionDisabled &&
              <div style={{ textAlign: 'center', marginTop: '50px', fontSize: '1.2rem', color: '#000' }}>
                Sorry, Essay Submission is not available right now. <br/>Please try again later.
              </div>
            }
            {
              viewMode == 'VIEW' &&
              <EssayView essayDetailLoaded={essayDetailLoaded} openTour={firstEssaySubmitted} essayFormDone={essayViewDone} essayId={recEssay.essayId} profileId={profileId} isSa={isSa} isSample={recEssay && recEssay.isSample}></EssayView>
            }
          </Box>
        </>
      )}
      <SpaCheck></SpaCheck>
      <PopSuggestion
        open={popShowFeedbackOpen}
        onClose={popShowFeedbackClose}
        essayId={recEssay.essayId}
      />

      <PopShare
        open={popShareOpen} onClose={popShareClose}
        essay={recEssay}
        allowMark={iamTEA}
      />
    </Box>
    
  );
}
